import Api from "@/services/api.js";

export default {
  props: ["produto"],
  data() {
    return {
      checkHover: false,
      arEstado: [],
      arIdEstado: [],
      arSelectedEstado: [],
      checkedItens: "none",
      expande: false
    };
  },
  components: {},
  created() {
    this.getEstados();
    this.setTributos();
  },
  watch: {
    produto: function() {
      this.setTributos();
    }
  },

  updated() {
    this.changeSelected();
  },
  methods: {
    expandirIcms() {
      this.$nextTick(() => {
        if (this.$refs.icmsSelect && this.$refs.icmsSelect.offsetHeight > 80) {
          this.expande = true;
        } else {
          this.expande = false;
        }
      });
    },
    emiteTributo() {
      this.$bus.$emit("emiteTributo");
    },
    getEstados: function() {
      this.arProduto = [];

      new Api().get("Estado/obterEstados").then(response => {
        this.arEstado = response.dados;
        this.arEstado.map(item => {
          this.arIdEstado.push(item.id_estado);
        });
      });
    },
    setTributos: function() {
      this.$props.produto.arTributos = [
        "",
        "",
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ];

      if (this.$props.produto.monitoria) {
        this.$props.produto.monitoria.forEach(x => {
          this.$props.produto.arTributos[x.id_tipo_monitoria] = true;
        });
      }

      if (this.$props.produto.id_tipo_monitoria) {
        this.$props.produto.id_tipo_monitoria.forEach(x => {
          this.$props.produto.arTributos[x] = true;
        });
      }

      if (typeof this.$props !== "undefined")
        if (this.$props.produto.icms_estado) {
          this.$props.produto.icms_estado.map(e => {
            if (e.id_estado) {
              e.id_estado = String(e.id_estado);
            }
          });
        }
    },
    changeSelected() {
      this.expandirIcms();
      this.emiteTributo();
      let icms_estado_length = 0;
      let arIdEstado_length = 0;
      if (this.produto.icms_estado && this.produto.icms_estado.length > 0) {
        icms_estado_length = this.produto.icms_estado.length;
      }
      if (this.arIdEstado && this.arIdEstado.length > 0) {
        arIdEstado_length = this.arIdEstado.length;
      }
      if (icms_estado_length == arIdEstado_length) {
        this.checkedItens = "all";
      } else if (icms_estado_length > 0 && icms_estado_length < arIdEstado_length) {
        this.checkedItens = "some";
      } else {
        this.checkedItens = "none";
      }
    },
    toggleAll() {
      this.emiteTributo();
      if (this.checkedItens == "all") {
        this.produto.icms_estado = [];
        this.checkedItens = "none";
        this.expandirIcms();
      } else {
        this.produto.icms_estado = this.arIdEstado.slice();
        this.checkedItens = "all";
        this.expandirIcms();
      }
    }
  }
};
